import { CommonModule } from "@angular/common";
import { ChangeDetectionStrategy, Component, computed, inject } from "@angular/core";

import {
  BannerMessage,
  BannerService,
  BannerSeverity,
} from "../../services/banner.service";

const SEVERITY_LABELS: Record<BannerSeverity, string> = {
  info: "Information",
  success: "Success",
  warning: "Warning",
  error: "Error",
};

@Component({
  selector: "app-application-banner-host",
  imports: [CommonModule],
  templateUrl: "./application-banner-host.component.html",
  styleUrl: "./application-banner-host.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ApplicationBannerHostComponent {
  private readonly bannerService = inject(BannerService);

  protected readonly banners = this.bannerService.banners;
  protected readonly politeAnnouncement = computed(() =>
    this.banners()
      .filter((banner) => banner.severity !== "error")
      .map((banner) => this.announcementFor(banner))
      .join(" "),
  );
  protected readonly assertiveAnnouncement = computed(() =>
    this.banners()
      .filter((banner) => banner.severity === "error")
      .map((banner) => this.announcementFor(banner))
      .join(" "),
  );

  protected dismiss(id: string): void {
    this.bannerService.dismiss(id);
  }

  protected iconFor(severity: BannerSeverity): string {
    switch (severity) {
      case "success":
        return "pi pi-check-circle";
      case "warning":
        return "pi pi-exclamation-triangle";
      case "error":
        return "pi pi-times-circle";
      default:
        return "pi pi-info-circle";
    }
  }

  protected trackBanner(_index: number, banner: BannerMessage): string {
    return banner.id;
  }

  protected severityLabel(severity: BannerSeverity): string {
    return SEVERITY_LABELS[severity];
  }

  private announcementFor(banner: BannerMessage): string {
    const severity = this.severityLabel(banner.severity);
    const title = banner.title.toLocaleLowerCase() === severity.toLocaleLowerCase()
      ? ""
      : `${banner.title}. `;
    return `${severity}: ${title}${banner.message}`;
  }
}
